import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { add_BTL_vendor, update_BTL_vendor } from "../../data/ApiEndpoints";

const validateForm = (formValues) => {
  let errors = {};
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const mobileRegex = /^\d{10}$/;
  const yopmailDomains = [
    "yopmail.com",
    "yopmail.net",
    "yopmail.fr",
    "yopmail.org",
  ];

  if (!formValues.vendorName) {
    errors.vendorName = "Category Name Required!";
  }

  if (!formValues.vendorMobile) {
    errors.vendorMobile = "required!";
  } else if (!mobileRegex.test(formValues.vendorMobile)) {
    errors.vendorMobile = "invalid!";
  }

  if (!formValues.vendorEmail) {
    errors.vendorEmail = "invalid!";
  } else if (
    formValues.vendorEmail &&
    !emailRegex.test(formValues.vendorEmail)
  ) {
    errors.vendorEmail = "invalid!";
  } else if (
    formValues.vendorEmail &&
    yopmailDomains.some((domain) => formValues.vendorEmail.includes(domain))
  ) {
    errors.vendorEmail = "Yopmail email addresses are not allowed!";
  }

  return errors;
};

const BTLVendorForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading } = useSelector((state) => state.postApi);

  const forminitials = {
    vendorName: isEdit && rowData?.name ? rowData.name : "",
    vendorMobile: isEdit && rowData?.mobile ? rowData.mobile : "",
    vendorEmail: isEdit && rowData?.email ? rowData.email : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    const updatedValue = name === "vendorMobile" ? value.slice(0, 10) : value;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : updatedValue,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_BTL_vendor : add_BTL_vendor;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.vendorName || "",
        mobile: formValues.vendorMobile || "",
        email: formValues.vendorEmail || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Vendor`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading || loading}
      />
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="vendorName" className={`formInputLabel `}>
              vendor name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Vendor Name"
              className={`formInput ${
                formErrors?.vendorName ? "formError" : ""
              }`}
              name="vendorName"
              value={formValues.vendorName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="vendorMobile" className={`formInputLabel `}>
              vendor mobile <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Vendor Name"
              className={`formInput ${
                formErrors?.vendorMobile ? "formError" : ""
              }`}
              name="vendorMobile"
              value={formValues.vendorMobile}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="vendorEmail" className={`formInputLabel `}>
              vendor email <span className="required">*</span>
            </label>

            <input
              type="email"
              placeholder="Enter Vendor Name"
              className={`formInput ${
                formErrors?.vendorEmail ? "formError" : ""
              }`}
              name="vendorEmail"
              value={formValues.vendorEmail}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default BTLVendorForm;
